import { useFormContext } from 'react-hook-form';

import { Schema } from '@typings';
import { contextNamesSelector } from '@selectors';
import { useSelector } from '@hooks';
import { as, path } from '@utils';

import { Button, Field, Modal } from '@components';
import { JobConstructorResourceStorageModal } from '@components/Job';

export const SchemaStoragePath: React.FC<Schema.CommonNodeProps> = ({
  name,
  label,
  note,
  required,
  error,
}) => {
  const { organizationName, clusterName, projectName } =
    useSelector(contextNamesSelector);

  const STORAGE_PREFIX = `storage://${clusterName}`;
  const DEFAULT_FILES_PATH = path.create(organizationName, projectName);

  const { register, setValue, watch } = useFormContext();

  const filesPath =
    as(watch(name), '').replace(STORAGE_PREFIX, '') || DEFAULT_FILES_PATH;

  const handlePathChange = ({ path: pathValue }: { path: string }) => {
    /**
     * Existing file path picker returns `currentPath` + `activeObjectName`.
     * There is duplicated `/` for root path.
     *
     * This will be removed with job integation
     */
    const path = pathValue.startsWith('//')
      ? pathValue.replace('//', '')
      : pathValue.replace('/', '');

    setValue(name, `${STORAGE_PREFIX}/${path}`);
  };

  return (
    <div className="flex flex-1">
      <div className="flex-1">
        <Field.Input
          {...register(name)}
          required={required}
          label={label}
          note={note}
          containerClassName="flex-1"
          className="w-full rounded-r-none"
          error={error}
        />
      </div>
      <Modal
        content={
          <JobConstructorResourceStorageModal
            resource={filesPath}
            onApply={handlePathChange}
          />
        }
      >
        <Button className="h-14 rounded-l-none">Browse</Button>
      </Modal>
    </div>
  );
};
